module.exports = __webpack_public_path__ + "img/no.dbc3cb9.svg";